import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from './apiClient';

export type PullRequest = {
  id: number;
  number: number;
  orgName: string;
  repoName: string;
  state: string;
  locked: boolean;
  title: string;
  body: string;
  createdAt: string;
  updatedAt: string;
  mergeable: boolean;
  rebaseable: boolean;
  lastComment: string;
  commits: number;
  additions: number;
  deletions: number;
  changedFiles: number;
  url: string;
  nbImpact: number;
};

export const pullRequestQueries = {
  all: () => ['pull-requests'],
  byProject: (projectId: string) => [...pullRequestQueries.all(), projectId],
  list: (projectId: string) =>
    queryOptions({
      queryKey: ['pull-requests', projectId],
      queryFn: async () => {
        const pullRequests = await listPullRequests(projectId);

        return pullRequests;
      },
    }),
} as const;

export const listPullRequests = async (
  projectId: string,
): Promise<PullRequest[]> => {
  const getResponse = await fetchBackend(`/pull-requests/list/${projectId}`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  return (await getResponse.json()).prs as PullRequest[];
};

export const fetchPullRequestDetails = async (
  projectId: string,
): Promise<PullRequest> => {
  const getResponse = await fetchBackend(`/pull-requests/list/${projectId}`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  return (await getResponse.json()) as PullRequest;
};
